import React from 'react';
import PropTypes from 'prop-types';
import { pickWithPriority } from 'Helpers/Affordances';
import fr from 'facet-rest';
import BalanceTransferRollover from './BalanceTransferRollover';

const BalanceTransferRolloverPicker = ({ tabResource }) => {
  return pickWithPriority(tabResource, [
    [fr.relationships.tabData.name, <BalanceTransferRollover tabDataRelationship={tabResource.relationship(fr.relationships.tabData.name)} />],
  ], () => null);
};

BalanceTransferRolloverPicker.propTypes = {
  tabResource: PropTypes.object.isRequired,
};

export default BalanceTransferRolloverPicker;
